// extracted by mini-css-extract-plugin
export var text = "_3z-0";